<template>
  <ConnectFeaturesDesktop :animation-enabled="animationEnabled" v-if="windowWidth >= 600" />
  <ConnectFeaturesMobile :animation-enabled="animationEnabled" v-else />
</template>

<script>
import { mapGetters } from 'vuex';
import ConnectFeaturesDesktop from './connect-features-desktop';
import ConnectFeaturesMobile from './connect-features-mobile';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  components: { ConnectFeaturesDesktop, ConnectFeaturesMobile },
  computed: {
    ...mapGetters('layoutModule', ['windowWidth']),
  }
};
</script>
